<form [formGroup]="annotationPropertiesForm">
  <div class="header-container">
    <div>
      <h2 mat-dialog-title class="dialog-header" transloco="PROPERTIES2"></h2>
    </div>
    @if (modifyDocumentPermission) {
      <div class="burn-button">
        <button
          mat-icon-button
          aria-label="Burn"
          matTooltip="{{ 'BURN' | transloco }}"
          (click)="toggleBurn()"
          [color]="
            annotationPropertiesForm.controls.burn.value ? 'warn' : 'primary'
          "
        >
          <mat-icon>local_fire_department</mat-icon>
        </button>
      </div>
    }
  </div>
  <mat-dialog-content>
    @if (showFill) {
      <h3 transloco="FILL"></h3>
    }
    @if (showFill) {
      <div class="input-container" formGroupName="fill">
        <mat-form-field>
          <mat-label transloco="COLOR"></mat-label>
          <input matInput placeholder="#ffffff" formControlName="color" />
          <ngx-colors
            class="color-picker-suffix"
            ngx-colors-trigger
            formControlName="color"
            format="hex"
            matSuffix
          ></ngx-colors>
          @if (annotationPropertiesForm.controls.fill.controls.color.invalid) {
            <mat-error
              >{{
                getValidationErrorMessage(
                  annotationPropertiesForm.controls.fill.controls.color
                )
              }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="OPACITY"></mat-label>
          <input
            matInput
            placeholder="1"
            min="0"
            max="1"
            step=".1"
            type="number"
            class="form-control"
            formControlName="opacity"
          />
        </mat-form-field>
      </div>
    }
    @if (showOutline) {
      <h3 transloco="OUTLINE"></h3>
    }
    @if (showOutline) {
      <div class="input-container" formGroupName="outline">
        <mat-form-field>
          <mat-label transloco="COLOR"></mat-label>
          <input matInput placeholder="#ffffff" formControlName="color" />
          <ngx-colors
            class="color-picker-suffix"
            ngx-colors-trigger
            formControlName="color"
            format="hex"
            matSuffix
          ></ngx-colors>
          @if (
            annotationPropertiesForm.controls.outline.controls.color.invalid
          ) {
            <mat-error
              >{{
                getValidationErrorMessage(
                  annotationPropertiesForm.controls.outline.controls.color
                )
              }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="OPACITY"></mat-label>
          <input
            matInput
            placeholder="1"
            min="0"
            max="1"
            step=".1"
            type="number"
            class="form-control"
            formControlName="opacity"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="THICKNESS"></mat-label>
          <input
            matInput
            placeholder="1"
            min="1"
            type="number"
            class="form-control"
            formControlName="thickness"
          />
        </mat-form-field>
        @if (showCornerRadius) {
          <mat-form-field>
            <mat-label transloco="CORNER_RADIUS"></mat-label>
            <input
              matInput
              type="number"
              class="form-control"
              min="0"
              max="100"
              formControlName="cornerRadius"
            />
          </mat-form-field>
        }
      </div>
    }
    @if (showText) {
      <h3 transloco="TEXT"></h3>
    }
    @if (showText) {
      <div class="row-container" formGroupName="text">
        @if (!isStamp) {
          <div class="toggle-group-container">
            <mat-button-toggle-group
              aria-label="Font Style"
              [hideMultipleSelectionIndicator]="true"
              formControlName="emphasis"
              multiple
            >
              <mat-button-toggle
                value="bold"
                aria-label="Bold"
                matTooltip="{{ 'BOLD' | transloco }}"
                ><mat-icon>format_bold</mat-icon></mat-button-toggle
              >
              <mat-button-toggle
                value="italic"
                aria-label="Italic"
                matTooltip="{{ 'ITALIC' | transloco }}"
                ><mat-icon>format_italic</mat-icon></mat-button-toggle
              >
              <mat-button-toggle
                value="strikeout"
                aria-label="Strikeout"
                matTooltip="{{ 'STRIKEOUT' | transloco }}"
                ><mat-icon>format_strikethrough</mat-icon></mat-button-toggle
              >
              <mat-button-toggle
                value="underline"
                aria-label="Underline"
                matTooltip="{{ 'UNDERLINE' | transloco }}"
                ><mat-icon>format_underlined</mat-icon></mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        }
        @if (!isStamp) {
          <div class="toggle-group-container">
            <mat-button-toggle-group
              aria-label="Alignment"
              formControlName="alignment"
              [hideSingleSelectionIndicator]="true"
            >
              <mat-button-toggle
                value="left"
                aria-label="Align Left"
                matTooltip="{{ 'ALIGN_LEFT' | transloco }}"
                ><mat-icon>format_align_left</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle
                value="center"
                aria-label="Align Center"
                matTooltip="{{ 'ALIGN_CENTER' | transloco }}"
                ><mat-icon>format_align_center</mat-icon></mat-button-toggle
              >
              <mat-button-toggle
                value="right"
                aria-label="Align Right"
                matTooltip="{{ 'ALIGN_RIGHT' | transloco }}"
                ><mat-icon>format_align_right</mat-icon></mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        }
      </div>
    }

    @if (showText && !isStamp) {
      <div class="input-container" formGroupName="text">
        <mat-form-field>
          <mat-label transloco="FONT"></mat-label>
          <mat-select formControlName="fontName">
            @for (font of availableFonts; track font) {
              <mat-option [value]="font">
                {{ font }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (showFill) {
          <mat-form-field>
            <mat-label transloco="FONT_SIZE"></mat-label>
            <input
              matInput
              placeholder="70"
              min="0"
              type="number"
              class="form-control"
              formControlName="fontSize"
            />
            @if (
              annotationPropertiesForm.controls.text.controls.fontSize.invalid
            ) {
              <mat-error
                >{{
                  getValidationErrorMessage(
                    annotationPropertiesForm.controls.text.controls.fontSize
                  )
                }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (showFill && !isStamp) {
          <mat-form-field>
            <mat-label transloco="COLOR"></mat-label>
            <input matInput placeholder="#ffffff" formControlName="color" />
            <ngx-colors
              class="color-picker-suffix"
              ngx-colors-trigger
              formControlName="color"
              format="hex"
              matSuffix
            ></ngx-colors>
            @if (
              annotationPropertiesForm.controls.text.controls.color.invalid
            ) {
              <mat-error
                >{{
                  getValidationErrorMessage(
                    annotationPropertiesForm.controls.text.controls.color
                  )
                }}
              </mat-error>
            }
          </mat-form-field>
        }
      </div>
    }
    @if (showText) {
      <div class="input-container" formGroupName="text">
        <mat-form-field>
          <mat-label transloco="TEXT"></mat-label>
          <textarea matInput #textArea formControlName="value"></textarea>
        </mat-form-field>
      </div>
    }
    @if (showStartCap) {
      <h3 transloco="START_CAP"></h3>
    }
    @if (showStartCap) {
      <div class="input-container" formGroupName="startCap">
        <mat-form-field>
          <mat-label transloco="WIDTH"></mat-label>
          <mat-select formControlName="width">
            @for (width of capWidthKeys; track width) {
              <mat-option [value]="capWidth[width]">{{ width }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="HEIGHT"></mat-label>
          <mat-select formControlName="height">
            @for (height of capHeightKeys; track height) {
              <mat-option [value]="capHeight[height]">{{ height }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="STYLE"></mat-label>
          <mat-select formControlName="style">
            @for (style of capStyleKeys; track style) {
              <mat-option [value]="style">{{ style }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (showEndCap) {
      <h3 transloco="END_CAP"></h3>
    }
    @if (showEndCap) {
      <div class="input-container" formGroupName="endCap">
        <mat-form-field>
          <mat-label transloco="WIDTH"></mat-label>
          <mat-select formControlName="width">
            @for (width of capWidthKeys; track width) {
              <mat-option [value]="capWidth[width]">{{ width }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="HEIGHT"></mat-label>
          <mat-select formControlName="height">
            @for (height of capHeightKeys; track height) {
              <mat-option [value]="capHeight[height]">{{ height }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label transloco="STYLE"></mat-label>
          <mat-select formControlName="style">
            @for (style of capStyleKeys; track style) {
              <mat-option [value]="style">{{ style }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close transloco="CANCEL"></button>
    <span class="spacer"></span>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button
      mat-button
      [disabled]="annotationPropertiesForm.invalid"
      (click)="save()"
      transloco="CONFIRM"
    ></button>
  </mat-dialog-actions>
</form>
